import _ from 'lodash';
import { useMemo } from 'react';
import useAuthorizationConfig from './UseAuthorizationConfig';
export default function usePermissionLevels() {
    var permissionLevels = useAuthorizationConfig().permissionLevels;
    var permissionLevelsArray = useMemo(function () {
        return _.values(permissionLevels);
    }, [permissionLevels]);
    return permissionLevelsArray;
}
//# sourceMappingURL=UsePermissionLevels.js.map